"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runtime = require("../runtime");
var _default = (0, _runtime.IconWrapper)('info_normal', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none",
      "stroke-width": props.strokeWidth
    }
  }, [h("g", {
    "attrs": {
      "id": "group-0",
      "stroke": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#3B64FC',
      "fill": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#3B64FC'
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
      "stroke": "none"
    }
  })]), h("g", {
    "attrs": {
      "id": "group-1",
      "stroke": props.colors && typeof props.colors !== 'string' && props.colors[1] || typeof props.colors === 'string' && props.colors || 'white',
      "fill": props.colors && typeof props.colors !== 'string' && props.colors[1] || typeof props.colors === 'string' && props.colors || 'white'
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 13C8.55228 13 9 12.5523 9 12V7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7V12C7 12.5523 7.44772 13 8 13ZM7 4C7 4.55229 7.44772 5 8 5C8.55228 5 9 4.55229 9 4C9 3.44771 8.55228 3 8 3C7.44772 3 7 3.44771 7 4Z",
      "stroke": "none"
    }
  })])]);
});
exports.default = _default;